module.exports = __webpack_public_path__ + "static/media/arrow-down.7c132893.svg";